export const formatPrice = price => `$${price.toFixed(2)}`;

export const formatPriceRange = (min, max) => min === max ? `${min.toFixed(2)}$` : `${min.toFixed(2)}$ - ${max.toFixed(2)}$`;
